<template>
  <table :class="{ compact }">
    <thead>
      <tr>
        <th></th>
        <th>BASIC</th>
        <th>PRO</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td class="txt--bold">Pengolahan Data</td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>Otomatis hitung Keliling, Diameter, LBDS, dan Tajuk</td>
        <td>
          <i class="material-icons teal-text">check</i>
        </td>
        <td>
          <i class="material-icons teal-text">check</i>
        </td>
      </tr>
      <!-- <tr>
        <td>Otomatis isi Nama Ilmiah, Famili, dan Habitus</td>
        <td><i class="material-icons red-text text-darken-3">clear</i></td>
        <td><i class="material-icons teal-text">check</i></td>
      </tr>-->
      <tr>
        <td>Data Summary</td>
        <td>
          <i class="material-icons red-text text-darken-3">clear</i>
        </td>
        <td>
          <i class="material-icons teal-text">check</i>
        </td>
      </tr>
      <tr>
        <td class="txt--bold">Backup Data</td>
        <td></td>
        <td></td>
      </tr>
      <tr>
        <td>Auto Backup (offline) and Restore (online)</td>
        <td>
          <i class="material-icons red-text text-darken-3">clear</i>
        </td>
        <td>
          <i class="material-icons teal-text">check</i>
        </td>
      </tr>
      <tr>
        <td>Download .xlsx (offline)</td>
        <td>
          <i class="material-icons teal-text">check</i>
        </td>
        <td>
          <i class="material-icons teal-text">check</i>
        </td>
      </tr>
      <tr>
        <td>Download .csv (offline)</td>
        <td>
          <i class="material-icons red-text text-darken-3">clear</i>
        </td>
        <td>
          <i class="material-icons teal-text">check</i>
        </td>
      </tr>
      <tr>
        <td>Save to Drive (online)</td>
        <td>
          <i class="material-icons red-text text-darken-3">clear</i>
        </td>
        <td>
          <i class="material-icons teal-text">check</i>
        </td>
      </tr>
      <tr>
        <td>Share to Other App (offline & online)</td>
        <td>
          <i class="material-icons red-text text-darken-3">clear</i>
        </td>
        <td>
          <i class="material-icons teal-text">check</i>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
table.compact {
  td,
  th {
    padding: 4px;
  }
}
</style>
